/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { InsertLinkDialog } from '../../../content-edit-controls';
import { urlTemplates, endpoints, linkStyleIframeSrc } from './constants';

const InsertLinkDialogWindow = ({ onSave, onCancel, params, showLinkStyleOption }) =>
{
  const {
    isSimpleView,
    openInNewWindow,
    isLinkTextEditable,
    imageLink,
    tooltip,
    link,
    title,
    isEditMode,
    styleNames,
    linkStyle
  } = params;

  const handleUnlink = () =>
  {
    const data = { ...params, link: ''};
    onSave(data);
  };

  const handleSave = (payload) =>
  {
    const data = {
      ...params,
      title: payload.linkText,
      openInNewWindow: payload.openInNewWindow,
      tooltip: payload.tooltip,
      link: payload.url,
      linkStyle: payload.linkStyle
    };

    onSave(data);
  };


  return (
    <InsertLinkDialog
      isSimpleView={isSimpleView}
      isEditMode={isEditMode}
      onCancel={onCancel}
      onSave={handleSave}
      onUnlink={handleUnlink}
      tooltip={tooltip}
      linkText={title}
      url={link}
      isLinkTextEditable={isLinkTextEditable}
      isLinkTextSectionHidden={!!imageLink}
      openInNewWindow={openInNewWindow}
      previewImage={imageLink}
      baseDetailsUrlTemplate={urlTemplates.baseDetailsUrlTemplate}
      baseRegistrationUrlTemplate={urlTemplates.baseRegistrationUrlTemplate}
      eventsEndpoint={endpoints.eventsEndpoint}
      pagesStructureEndpoint={endpoints.pagesStructureEndpoint}
      linkStyles={styleNames}
      linkStyle={linkStyle}
      linkStyleIframeSrc={linkStyleIframeSrc}
      isLinkStyleSectionHidden={!showLinkStyleOption}
    />
  );
};

InsertLinkDialogWindow.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  params: PropTypes.shape({}).isRequired
};


export default InsertLinkDialogWindow;